import React from "react";
import { Table } from "@material-ui/core";
import classnames from "classnames";

export default ({ children, classes, ...props }) => {
	return <Table {...props}>{children}</Table>;
};
